/**
 * This is the public-api for your package. Export everything here that
 * you would like consumers to use.
 */
export const name = 'Figma';

// Components...
export { default as EditorSidebarButton } from './components/EditorSidebarButton';
export { default as EditorSidebarView } from './components/EditorSidebarView';

// Contexts
export * as APIClientContext from './context/apiClient';

export * as EditorContext from './context/editor';
